export const AUTH_CODES = {
    registerNewUser: 402
};

